import { createFileRoute } from "@tanstack/react-router"
import { SubscriptionPage } from "@/pages/profile/subscription"

export const Route = createFileRoute("/_authenticated/profile/subscription/")({
	component: SubscriptionPage,
})
